require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-project-how-can-the-world-bank-promote-the-inclusion-of-marginalized.json") })
        }
      }, "path---en-us-project-how-can-the-world-bank-promote-the-inclusion-of-marginalized");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-project-how-can-the-world-bank-promote-the-inclusion-of-marginalized!./.cache/json/en-us-project-how-can-the-world-bank-promote-the-inclusion-of-marginalized.json
// module id = 519
// module chunks = 231608221292675